import {pluginName, pluginNameToString} from '@packages/systems/wfdl-Qualified';

// pluginName lives in the Qualified package, but we export it from here in
// order to utilize the Plugins namespace.
// i.g: Plugins.name('Basic')
export const name = pluginName;

export const nameToString = pluginNameToString;
